import { Button } from "@/components/ui/button";

interface LinkedInSubscribeButtonProps {
  className?: string;
}

const LinkedInSubscribeButton = ({ className }: LinkedInSubscribeButtonProps) => {
  const handleSubscribe = () => {
    window.open(
      "https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7124602099836887040",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <Button
      onClick={handleSubscribe}
      className={`bg-[#0A66C2] hover:bg-[#004182] text-white font-medium transition-all duration-300 ${className}`}
      size="lg"
      aria-label="Subscribe to d(AI)ly Circus newsletter on LinkedIn"
    >
      Subscribe on LinkedIn
    </Button>
  );
};

export default LinkedInSubscribeButton;